<template>
<div>
    <!-- 修改企业注册信息 -->
    <el-dialog
      title="提交企业注册信息"
      width="910px"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :visible.sync="isEditVisiable"
      :before-close="cancle"
    >
        <el-form :model="companyInfo" :rules="companyRule" ref="companyInfo" label-width="150px" style="width:96%;">
            <el-form-item label="企业名称：" prop="companyName">
                <el-input placeholder="请输入" v-model.trim="companyInfo.companyName"  maxlength="64"></el-input>
            </el-form-item>
            <el-form-item label="企业地址：" prop="enterpriseAddress">
                <el-input placeholder="请输入" v-model.trim="companyInfo.enterpriseAddress"  maxlength="128"></el-input>
            </el-form-item>
            <el-form-item label="企业人数：" prop="numberOfEnterprises">
                <el-input placeholder="请输入" v-model.trim="companyInfo.numberOfEnterprises"  maxlength="5"></el-input>
            </el-form-item>

            <el-form-item label="营业执照注册号：" prop="enterpriseLicenseNumber">
                <el-input placeholder="请输入" v-model.trim="companyInfo.enterpriseLicenseNumber" maxlength="15"></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码：" prop="unifiedSocialCreditCode">
                <el-input placeholder="请输入" v-model.trim="companyInfo.unifiedSocialCreditCode" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="企业介绍：" prop="enterpriseIntroduction">
                <el-input placeholder="请输入" type="textarea" v-model.trim="companyInfo.enterpriseIntroduction" maxlength="2000" rows="5" resize="none"></el-input>
            </el-form-item>
            <!--营业执照：  -->
            <el-form-item label="营业执照：" class="requisite3" style=" position: relative;">
                <div class="img_boxs" v-for="(item,idx) in companyInfo.fileInfoList" :key="idx" style="display: inline-block;margin-right: 10px;cursor: pointer;position: relative;">
                    <img :src="item.licenseStoragePath" @click="imgVisible=true;preImg=item.licenseStoragePath"/>
                    <i class="img_close el-icon-close" @click="closeImg(idx)"></i>
                </div>
                <!-- 上传图片 -->
                <form id="fileUploadF"  :action='action' method='post' target='targetIframe' enctype="multipart/form-data" v-show="companyInfo.fileInfoList.length!=5">
                <div class="add_img" v-show="companyInfo.fileInfoList.length!=5">
                    <i class="el-icon-picture-outline"></i>
                    <input id="fileId" type="file" name="file" @change="upChange">
                    <input  id="appModule" type="hidden" name="appModule" value="companyNews">
                    <div>点击上传图片</div>
                </div>
                </form>
            </el-form-item>
            <div style="color:#909399;margin-left:150px;line-height:40px;font-size:14px;position: relative;top: -20px;">
                仅支持jpg、png两种格式，大小不超过4MB
            </div>
            <!--金融许可证：  -->
            <el-form-item label="企业业务许可证/金融许可证：">
                <div class="img_boxs" v-for="(item,idx) in companyInfo.licenseInfoList" :key="idx" style="display: inline-block;margin-right: 10px;cursor: pointer;position: relative;">
                    <img :src="item.permitStoragePath" @click="imgVisible=true;preImg=item.permitStoragePath"/>
                    <i class="img_close el-icon-close" @click="closeImg2(idx)"></i>
                </div>
                <!-- 上传图片 -->
                <form id="fileUploadF2"  :action='action' method='post' target='targetIframe2' enctype="multipart/form-data" v-show="companyInfo.licenseInfoList.length!=5">
                <div class="add_img" v-show="companyInfo.licenseInfoList.length!=5">
                    <i class="el-icon-picture-outline"></i>
                    <input id="fileId2" type="file" name="file" @change="upChange2">
                    <input  id="appModule" type="hidden" name="appModule" value="companyNews">
                    <div>点击上传图片</div>
                </div>
                </form>
            </el-form-item>
            <div style="color:#909399;margin-left:150px;line-height:40px;font-size:14px;position: relative;top: -20px;">
                仅支持jpg、png两种格式，大小不超过4MB
            </div>

            <!-- <el-form-item label="企业业务许可证/金融许可证：" prop="licenceId">
                <img :src="item.permitStoragePath" v-for="(item,idx) in companyInfo.licenseInfoList" @click="imgVisible=true;preImg=item.permitStoragePath" :key="idx" style="width:80px;height:80px;display: inline-block;margin: 10px 10px 0 0;cursor: pointer;">
            </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center;">
            <el-button type="primary" @click.native="submit">保存并提交</el-button>
            <el-button @click.native="cancle">取消</el-button>
        </div>
    </el-dialog>
    <!-- 图片预览 -->
    <el-dialog :visible.sync="imgVisible" class="previewImg" width="44%" :modal-append-to-body="false">
      <img :src="preImg" alt="">
    </el-dialog>
    <!-- 隐藏iframe -->
    <iframe name='targetIframe' style="display: none;" @load="iframeLoad" id="targetIframe"></iframe>
    <!-- 隐藏iframe -->
    <iframe name='targetIframe2' style="display: none;" @load="iframeLoad2" id="targetIframe2"></iframe>
</div>
</template>

<script>
import { Dialog, Form, FormItem, Input, Button, Message } from 'element-ui';

export default {
    components: {
        'el-dialog': Dialog,
        'el-form': Form,
        'el-form-item': FormItem,
        'el-input': Input,
        'el-button': Button
    },
    data(){
        return{
            disabled: false,
            // 注册企业信息
            companyInfo: {
                userTypeId:  window.sessionStorage.getItem('officialWebsiteUserMsg') ? JSON.parse(window.sessionStorage.getItem('officialWebsiteUserMsg')).webUserId : '',
                userName: window.sessionStorage.getItem('officialWebsiteUserMsg') ? JSON.parse(window.sessionStorage.getItem('officialWebsiteUserMsg'))?.webUserName : '',
                companyName: '',
                enterpriseAddress: '',
                numberOfEnterprises:  '',
                enterpriseLicenseNumber: '',
                unifiedSocialCreditCode: '',
                enterpriseIntroduction: '',

                // 营业执照文件列表
                fileInfoList: [],
                // 金融许可证列表
                licenseInfoList: [],
            },
            imgVisible: false,
            preImg: '',
            // 企业
            companyRule:{
                companyName: { required: true,message:'请输入企业名称'},
                enterpriseAddress: { required: true,message:'请输入企业地址'},
                numberOfEnterprises: [
                    { required: true,message:'请输入企业人数'},
                    { pattern: /^[0-9]+$/, message: "请输入数字", trigger: "change" },
                ],
                enterpriseLicenseNumber: { required: true,message:'请输入营业执照注册号'},
                unifiedSocialCreditCode:[
                    { required: true,message:'请输入统一社会信用代码', trigger: "change" },
                    { pattern: /^[0-9A-Z]+$/, message: "限制输入大写字母和数字", trigger: "change" },
                    { min: 18, message: "请输入18位统一社会信用代码", trigger: "blur" },
                ],
                enterpriseIntroduction: { required: true,message:'请输入企业介绍'},
                enterpriseLicenseId: { required: true ,message: ""},
            },
            isEditVisiable: false,
            action:process.env.VUE_APP_BASE_API+"/gatewayWebsiteServer/uploadFile",
        }
    },
    methods:{
        // 初始
        async init(){
            // if (window.sessionStorage.getItem('companyId') != null) {
            //     this.disabled = JSON.parse(window.sessionStorage.getItem('officialWebsiteUserMsg')).webUserType != 0
                let res = await this.$api.showroomDetail({
                    webUserId:JSON.parse(window.sessionStorage.getItem('officialWebsiteUserMsg')).webUserId
                });
                if (res.data.resultCode === 200 && res.data.result) {
                    if (res.data.result.status == 1) {
                        return this.$message.error("已完成企业入驻，无需再次操作")
                    }
                    this.disabled = res.data.result.status != 2
                    this.companyInfo = Object.assign({},this.companyInfo,res.data.result);
                    this.isEditVisiable = true;
                } else {
                    this.isEditVisiable = true;
                }
            // } else {
            //      this.isEditVisiable = true;
            // }
        },
        // 保存数据
        submit(){
            this.$refs['companyInfo'].validate( async (valid) => {
                if (valid) {
                    if( Number(this.companyInfo.numberOfEnterprises) === 0 ){
                        return this.$message.error("企业人数不能小于0")
                    }
                    if( this.companyInfo.fileInfoList.length == 0 ){
                        return this.$message.error("请上传营业执照！")
                    }
                    let postData = Object.assign({},this.companyInfo);
                    postData.enterpriseLicenseId = ''
                    postData.enterpriseName = this.companyInfo.companyName
                    postData.enterpriselicenseNumber = this.companyInfo.enterpriseLicenseNumber
                    postData.licenceId = ''
                    // 营业执照
                    postData.fileInfoList.map((ele,i)=>{
                        if( i === postData.fileInfoList.length-1 ){
                            postData.enterpriseLicenseId += ele.fileId
                        }else{
                            postData.enterpriseLicenseId += ele.fileId +','
                        }
                    })
                    // 许可证
                    postData.licenseInfoList.map((ele,i)=>{
                        if( i === postData.fileInfoList.length-1 ){
                            postData.licenceId += ele.fileId
                        }else{
                            postData.licenceId += ele.fileId +','
                        }
                    })
                    delete postData.fileInfoList
                    delete postData.licenseInfoList
                    console.log(postData)
                    let res;
                    if (this.companyInfo.id != null) {
                        res = await this.$api.modifyEnterprise(postData);
                    } else {
                        res = await this.$api.inserEnterprise(postData);
                    }
                    if(res.data.resultCode === 200 ){
                        this.$message.success('提交成功，请等待审核');
                        // this.$parent.upgradeInfo();
                        this.isEditVisiable = false;
                    }else{
                        this.$message.warning(res.data.resultDesc);
                    }
                } else {
                    return false;
                }
            });
        },
        // 关闭弹窗
        cancle: function() {
            this.$refs['companyInfo'].resetFields();
            this.isEditVisiable = false;
        },
        // 选取文件--营业执照
        upChange(e){
            var fileEle = document.getElementById('fileId');
            var fileObj = null;
            if(fileEle.files){
                fileObj = fileEle.files[0];
            }else{
                fileEle.select();
                fileEle.blur();
                var filePath = document.selection.createRange().text;
                fileObj = document.selection.createRange();
            }
            console.log('fileObj',fileObj);
            var testmsg = fileObj.name.substring(fileObj.name.lastIndexOf('.') + 1);
            const extension = testmsg === 'jpg' || testmsg === 'JPG' || testmsg === 'png' || testmsg === 'PNG' ;
            if (!extension ) {
				this.$message.error('仅支持jpg、png两种格式');
				return false
			}
            const isLt4M = fileObj.size / 1024 / 1024 < 4;
            if(!isLt4M){
                this.$message.error('上传图片大小不能超过 4M!');
				return false
            }
            if(fileObj){
                var form = document.getElementById("fileUploadF");
                form.submit();
                form.reset(); // 提交完进行重置form表单
            }
        },
        // 选取文件--许可证
        upChange2(e){
            var fileEle = document.getElementById('fileId2');
            var fileObj = null;
            if(fileEle.files){
                fileObj = fileEle.files[0];
            }else{
                fileEle.select();
                fileEle.blur();
                var filePath = document.selection.createRange().text;
                fileObj = document.selection.createRange();
            }
            console.log('fileObj',fileObj);
            var testmsg = fileObj.name.substring(fileObj.name.lastIndexOf('.') + 1);
            const extension = testmsg === 'jpg' || testmsg === 'JPG' || testmsg === 'png' || testmsg === 'PNG' ;
            if (!extension ) {
				this.$message.error('仅支持jpg、png两种格式');
				return false
			}
            const isLt4M = fileObj.size / 1024 / 1024 < 4;
            if(!isLt4M){
                this.$message.error('上传图片大小不能超过 4M!');
				return false
            }
            if(fileObj){
                var form = document.getElementById("fileUploadF2");
                form.submit();
                form.reset(); // 提交完进行重置form表单
            }
        },
        // iframe获取信息--营业执照
        iframeLoad(){
            var result=document.getElementById('targetIframe').contentWindow.document.body.innerText;
            if(!result){
                return
            }
            let res = JSON.parse(result);
            if(res.resultCode === 200 ){
                this.$message.success("上传成功！");
                let list =  {
                    fileId: res.fileId,
                    licenseStoragePath: res.filePath,
                    licenseFileName: res.licenseFileName
                }
                this.companyInfo.fileInfoList.push(list);
            }else{
                this.$message.error(res.resultDesc);
            }
        },
        // iframe获取信息--许可证
        iframeLoad2(){
            var result=document.getElementById('targetIframe2').contentWindow.document.body.innerText;
            if(!result){
                return
            }
            let res = JSON.parse(result);
            console.log(res)
            if(res.resultCode === 200 ){
                this.$message.success("上传成功！");
                let list =  {
                    fileId: res.fileId,
                    permitStoragePath: res.filePath,
                    permitFileName: res.licenseFileName
                }
                this.companyInfo.licenseInfoList.push(list)
            }else{
                this.$message.error(res.resultDesc);
            }
        },
        // 删除图片
        closeImg(index){
            this.companyInfo.fileInfoList.splice(index,1)
        },
        // 删除图片
        closeImg2(index){
            this.companyInfo.licenseInfoList.splice(index,1)
        }
    }
}
</script>

<style lang="scss">
.add_img {
  float: left;
  width: 116px;
  height: 116px;
  line-height: 25px;
  background-color: #eee;
  color: #666666;
  font-size: 14px;
  text-align: center;
  position: relative;
  cursor: pointer;
  input{
    position: absolute;
    width: 116px;
    height: 116px;
    left: 0;
    top: 0;
    z-index: 0;
    opacity: 0;
  }
  .el-icon-picture-outline {
    font-size: 30px;
    margin-top: 30px;
  }
}
.img_boxs {
  float: left;
  img {
    width: 116px;
    height: 116px;
    margin-right: 10px;
  }
}
.requisite3::before{
  content: '*' !important;
  color: #f56c6c;
  position: absolute;
  left: 58px;
  top: 10px;
}
</style>
